import {fetchGet, generateEndpoint} from "../utils/request";

export const getOrganizationVaccines = async() => {
  const url = `${generateEndpoint('getOrganizationVaccines')}`
  return fetchGet(url, null)
}
